module.exports = __webpack_public_path__ + "static/oranges-59866d7e32ffd07855907832e7794064.png";